import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';

import { InputNumberFormat } from 'twyne-new.ui';

class InputDecimal extends React.Component {
  render() {
    const { containerProps = {}, setValue, getValue, isPristine, isRequired, getErrorMessage, isValid, disabled, displayType, decimalSeparator, suffix, decimalScale, fixedDecimalScale, thousandSeparator, prefix, isAllowed, allowNegative } = this.props;
    const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid' : '';

    const handleChange = (values) => {
      const { value } = values;
      setValue(value);

      const cb = this.props.onChange;
      if (cb) {
        cb(value);
      }
    };

    return (
      <div {...containerProps}>
        <InputNumberFormat
          className={'form-control ' + isInvalidClass}
          onValueChange={handleChange}
          value={getValue() || ''}
          disabled={disabled}

          {...{
            thousandSeparator,
            prefix,
            displayType,
            decimalSeparator,
            suffix,
            decimalScale,
            fixedDecimalScale,
            isAllowed,
            allowNegative
          }}
        />
        <span className="invalid-feedback">
          {getErrorMessage()}
          {isRequired() && !getValue() && ' Field required'}
        </span>
      </div>
    );
  }
}

InputDecimal.propTypes = {
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  getErrorMessage: PropTypes.func,
  isValid: PropTypes.func,
  isPristine: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

InputDecimal.defaultProps = {
  disabled: false,
  thousandSeparator: true,
  prefix: '$ '
}

export default withFormsy(InputDecimal);
